<template>
  <DynamicText
    tag="span"
    styleGroup="Offer Header"
    :get="offerTextStyle.get"
    :set="offerTextStyle.set"
    ><slot
  /></DynamicText>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DynamicText from "../DynamicText.vue";

import { Brand } from "@fresh8/types";

export default defineComponent({
  name: "BrandedOfferHeader",
  components: {
    DynamicText
  },
  setup() {
    return {
      offerTextStyle: {
        get(brand: Brand) {
          return brand.adTemplate.offer?.header;
        },
        set(brand: Brand, value: string) {
          if (!brand.adTemplate.offer) {
            brand.adTemplate.offer = {
              header: "",
              body: "",
              button: "",
              terms: ""
            };
          }

          brand.adTemplate.offer.header = value;
        }
      }
    };
  }
});
</script>
